import { Close, PersonAddAlt1Outlined } from '@mui/icons-material';
import { Box, Dialog, DialogTitle, Grid2, IconButton, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { Stack, useMediaQuery } from '@mui/system';
import { TariffsContextProvider } from 'contexts/tariffs/TariffsContext';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import ConfigureCommunityMemberDialogContent from './ConfigureCommunityMemberDialogContent';

const NewCommunityMemberConfigureMembersDialog = ({ open, onClose, onSuccess, installation = null }) => {

    const isMobileVersion = useMediaQuery((theme) => theme.breakpoints.down('lg'));

    const { t } = useTranslation();

    const handleClose = () => {
        onClose();
    }

    return (
        <TariffsContextProvider>
            <Dialog open={open} fullScreen>
                <DialogTitle>
                    <Grid2 container>
                        <Grid2 item size={{ xs: 9, sm: 6 }}>
                            <Stack spacing={2} direction="row" alignItems="center">
                                <IconButton onClick={handleClose}>
                                    <Close />
                                </IconButton>
                                <PersonAddAlt1Outlined color="primary" />
                                <Typography variant="subtitle1" color="textPrimary">{t("label.button.newMember")}</Typography>
                            </Stack>
                        </Grid2>
                        <Grid2 item size={{ xs: 3, sm: 6 }} alignItems={"center"}>
                            <Box sx={{ display: 'flex', flexGrow: 1, height: "100%", alignItems: "center", justifyContent: "flex-end" }}>
                                <Stepper activeStep={1} orientation="horizontal">
                                    <Step key={0}>
                                        <StepLabel>{!isMobileVersion && t("label.title.configureInstallation")}</StepLabel>
                                    </Step>
                                    <Step key={1}>
                                        <StepLabel>{!isMobileVersion && t("label.title.configureClient")}</StepLabel>
                                    </Step>
                                    <Step key={2}>
                                        <StepLabel>{!isMobileVersion && t("label.title.configureTariffPlan")}</StepLabel>
                                    </Step>
                                </Stepper>
                            </Box>
                        </Grid2>
                    </Grid2>
                </DialogTitle>
                <ConfigureCommunityMemberDialogContent open={open} onClose={onClose} onSuccess={onSuccess} installation={installation} />
            </Dialog>
        </TariffsContextProvider>
    );
}

export default NewCommunityMemberConfigureMembersDialog;